import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Typography } from '@material-ui/core'
import AnimatedLoader from './AnimatedLoader'
import { isChunkLoadError, reloadStaleChunk } from 'utils/staleChunkReload'

const AsyncLoader = ({ isLoading, error }) => {
  // Falha ao baixar o chunk da tela (deploy novo ou rede): recarrega a página
  // uma vez automaticamente. Enquanto o reload acontece, mantém o loader.
  const [reloading, setReloading] = useState(false)

  useEffect(() => {
    if (error && isChunkLoadError(error)) {
      setReloading(reloadStaleChunk())
    }
  }, [error])

  if (isLoading || reloading) {
    return <AnimatedLoader />
  }

  if (error) {
    // eslint-disable-next-line no-console
    console.log(error)
    return (
      <Box p={3} textAlign='center'>
        <Typography gutterBottom>
          Não foi possível carregar a página.
        </Typography>
        <Button
          color='primary'
          variant='contained'
          onClick={() => window.location.reload()}
        >
          Recarregar
        </Button>
      </Box>
    )
  }

  return null
}

AsyncLoader.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isLoading: PropTypes.bool,
}

export default AsyncLoader
